import React from "react";
import "./App.css";
import Header from "./components/Header";
import PermitForm from "./components/PermitForm";
import Footer from "./components/Footer";
import { ConfigProvider, useConfig } from "./contexts/ConfigContext";

const LoadingScreen = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-blue-50">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600 mb-4"></div>
      <h2 className="text-2xl font-semibold text-gray-700">Loading...</h2>
      <p className="text-gray-600 mt-2">
        Please wait while we prepare your application.
      </p>
    </div>
  </div>
);

const AppContent = () => {
  const { loading, error } = useConfig();

  if (loading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-red-50">
        <div className="text-center p-8 max-w-md">
          <div className="inline-block rounded-full h-12 w-12 bg-red-100 text-red-600 mb-4 flex items-center justify-center">
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-semibold text-gray-700 mb-2">
            Error Loading Application
          </h2>
          <p className="text-gray-600">{error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow bg-blue-50 py-8 md:py-12">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Parking Permit Registration
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Get quick and easy access to our parking facilities by registering
              for a permit today.
            </p>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-4 md:p-8 max-w-4xl mx-auto">
            <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-center text-gray-800">
              Complete Your Application
            </h3>
            <p className="text-gray-600 mb-8 text-center">
              Please fill out the form below to apply for a parking permit. All
              fields marked with an asterisk (*) are required.
            </p>
            <PermitForm />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ConfigProvider>
      <AppContent />
    </ConfigProvider>
  );
}

export default App;
